// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ed5baa0d","977":"82a6cc0b"}[chunkId] + ".chunk.js";
};